<template>
  <section class="content-width">
    <p>
      <span class="biggest">Hey,</span><br>
      <span class="bigger">My name is Andrey Radchishin.</span><br>
      I was born in Ukraine and currently live in Georgia, USA.<br>
      I am a software developer, among other things.
    </p>
  </section>
</template>

<script>

export default {
}
</script>

<style lang="scss" scoped>
@import '@/styles/sizes.scss';

section {
  margin-bottom: 48px;
  text-align: center; 
}

.biggest {
  font-size: 1.5rem;
}

.bigger {
  font-size: 1.25rem;
}
</style>
